var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 1.99984C14 1.2665 13.37 0.666504 12.6 0.666504H1.4C0.63 0.666504 0 1.2665 0 1.99984V9.99984C0 10.7332 0.63 11.3332 1.4 11.3332H12.6C13.37 11.3332 14 10.7332 14 9.99984V1.99984ZM12.6 1.99984L7 5.33317L1.4 1.99984H12.6ZM12.6 9.99984H1.4V3.33317L7 6.6665L12.6 3.33317V9.99984Z",
    fill: "#343435"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/Mail.72137b88de227d036704a2f193f2130c.svg";
export { ForwardRef as ReactComponent };